import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import axios from 'axios';

import { Table, Button, Icon, Popup, List, Accordion } from 'semantic-ui-react';

import { getJobs } from "../../../reducers/jobs";

import config from '../../../config/';
import epsgListing from '../../../config/epsgListing';

// Process name, which is the same as the layer name.
const ProcessNameCell = ({ layerName, name, is_secured, acl }) => (
  <Table.Cell>
    <Popup
      hoverable
      content={`${layerName}`}
      trigger={<p>{name}{is_secured ? <Icon name='lock' /> : (acl ? <Icon name='lock open' /> : null)}</p>}
    />
  </Table.Cell>
);

const FileRow = ({ name, color, details }) => {
  return (
    <List.Item
      icon={details && 'checkmark'}
      style={{ color: color }}
      content={
        <Popup
          content={details ?
            `Tiedosto on ladattu. Muokkauksen aikaleima: ${new Date(details.last_modified * 1000).toLocaleString('fi-FI')}` :
            "Tiedostoa ei löydy järjestelmästä."
          }
          trigger={<p>{name}</p>}
        />
      }
    />
  );
}

class FileCell extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
    }
  }

  toggleVisibility() {
    this.setState({ isOpen: !this.state.isOpen })
  }

  render () {
    const { processFiles, missingFiles, isReady } = this.props;

    return (
      <Table.Cell textAlign='left'>
        <Accordion>
          <Accordion.Title active={this.state.isOpen} onClick={e => this.toggleVisibility()} >
            <Icon name='dropdown' />
          </Accordion.Title>
          <Accordion.Content active={this.state.isOpen}>
            <List>
              {processFiles.map(f => (
                <FileRow
                  color="green"
                  key={f.name}
                  name={f.name}
                  details={f}
                  isReady={isReady}
                />
              ))}
              {missingFiles.map(f => (
                <FileRow
                  color="red"
                  key={f}
                  name={f}
                  details={null}
                  isReady={isReady}
                />
              ))}
            </List>
          </Accordion.Content>
        </Accordion>
      </Table.Cell>
    )
  }
}


// Button to start a process
const ConnectedStartButtonCell = connect(state => ({}),
        dispatch => bindActionCreators({
          getJobs: () => getJobs(),
        }, dispatch)
)(class StartButtonCell extends Component {

  startProcess() {
    axios.post(config.api.startProcess, { process: this.props.name });
    setTimeout(() => {
      this.props.getJobs();
    }, 2000);
    this.props.setRunning();
  }

  render() {
    const { isAvailable, filesReady, isRunning } = this.props;
    return(
      <Table.Cell>
          <Button
            loading={isRunning}
            onClick={e => {
              isAvailable && filesReady && this.startProcess();
            }}
            content="Käynnistä prosessi"
            disabled={!isAvailable}
          />
      </Table.Cell>
    );
  }
})

// Button to review and approve the result of a process
class PreviewButtonCell extends Component {
  constructor(props) {
    super(props);
    this.state = {
      buttonClicked: false,
    }
  }

  openPreview() {
    this.props.openPreview(this.props.workspace, this.props.name, this.props.displayName, this.props.apikey);
  }

  render() {
    const { isAvailable, filesReady } = this.props;
    const processRunning = this.props.isRunning || this.state.buttonClicked;
    const canPublish = !processRunning && filesReady && isAvailable;
    return(
      <Table.Cell>
          <Button
            onClick={e => this.openPreview()}
            disabled={!canPublish}
          >
            <Icon name='map' />
            {"Julkaise"}
          </Button>
      </Table.Cell>
    )
  }
}

// Info button to show coordinate reference system and other process details
const ProcessInfoCell = ({ process }) => (
  <Table.Cell textAlign='center'>
    {process && process.source_srs &&
      <Popup
        content={`Lähtöaineiston oletettu koordinaattijärjestelmä: ${epsgListing[process.source_srs]}`}
        trigger={<Button icon='info' />}
      />
    }
  </Table.Cell>
);

export default class ProcessRow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isRunning: false, // Private state that is used manually
    }
  }

  static getDerivedStateFromProps(props, state) {
    const newState = {};
    // Reset manual state isRunning when we got new props signal
    if (props.isRunning) {
      newState.isRunning = false;
    }
    return newState;
  }

  render() {
    const { name, process } = this.props;
    process.source_files.sort(); // Sort to see files in alphabetical order.
    return (
      <Table.Row  positive={this.props.isAvailable}>
        <ProcessNameCell layerName={name} name={process.name} is_secured={process.details.is_secured} acl={process.acl || null} />
        <FileCell
          processFiles={process.source_files}
          missingFiles={process.missing_files}
        />
        <ProcessInfoCell process={process}/>
        <ConnectedStartButtonCell
          name={this.props.name}
          isRunning={this.props.isRunning || this.state.isRunning}
          isAvailable={this.props.isAvailable}
          filesReady={!this.props.pending}
          setRunning={() => {
            this.setState({ isRunning: true });
            // Set timeout if the process is too fast to be running via props
            setTimeout(() => {
              this.setState({ isRunning: false });
            }, 15000);
          }}
        />
        {process.details.previous_action === 'publish' ?
          <Table.Cell textAlign='center'>Julkaistu</Table.Cell> :
          <PreviewButtonCell
            displayName={process.name}
            name={this.props.name}
            isRunning={this.props.isRunning || this.state.isRunning}
            isAvailable={this.props.isAvailable}
            filesReady={!this.props.pending}
            openPreview={this.props.openPreview}
            workspace={this.props.workspace}
            apikey={process.details.apikey}
          />
        }
      </Table.Row>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/main/processes/ProcessRow.js